<template>
  <div
    id="content-image"
    v-if="!loading">
    <v-divider></v-divider>

    <!-- Edit Form -->
    <form
      name="imageContentItemForm"
      class="mt-5"
      v-if="tab === 'edit'"
      @submit.prevent="updateContentItem('imageItemUpdate')">
      <ImageInput
        :aspectRatioWidth="width"
        :aspectRatioHeight="height"
        :imageMode="this.$store.state.cropImageInformation.imageMode"
        :src="this.$store.state.cropImageInformation.imageSrc"
      />

      <div class="d-flex justify-space-between">
        <p v-if="this.determineRecommendedImageSize() !== 'hideSuggestedSize'">
          Suggested Image Size:
          {{this.determineRecommendedImageSize()}}
        </p>

        <p v-if="this.$store.state.cropImageInformation.imageMode === 'crop'">
          Crop Box Dimensions:
          {{this.CropBoxDimensions}}
        </p>
      </div>

      <div class="page-buttons d-flex my-5">
        <v-btn
          type="button"
          color="primary"
          class="order-3 mr-5"
          :disabled="this.$store.state.cropImageInformation.imageMode === 'view'"
          @click="tempCropImage()">
          Crop
        </v-btn>
        <v-btn
          type="submit"
          color="primary"
          class="order-4">
          Save
        </v-btn>

        <v-btn
          type="button"
          color="primary"
          class="mr-5 order-2"
          :disabled="this.$store.state.cropImageInformation.imageSrc === ''"
          @click="clearImageSrc()">
          Remove
        </v-btn>

        <v-btn
          type="button"
          color="primary"
          class="mr-5 order-1"
          outlined
          @click="$refs.fileUpload.click()">
          Upload
          <input
            ref="fileUpload"
            @input="receiveFile($refs.fileUpload.files)"
            type="file"
            accept="image/png,image/gif,image/jpeg"
            hidden
          />
        </v-btn>

        <v-btn
          @click="goToContentList"
          type="button"
          color="primary"
          class="mr-auto order-0"
          outlined>
          Cancel
        </v-btn>
      </div>
    </form>
    <!-- / Edit Form -->

    <!-- Revisions -->
    <Revisions
      v-if="tab === 'revisions'"
      type="image"
    />
    <!-- / Revisions -->
  </div>
</template>

<script>
import _ from 'lodash';
import ContentItemMixin from '../mixin.content-item';
import ImageInput from './ImageInput.vue';
import Revisions from './Revisions.vue';

export default {
  name: 'ContentImage',
  props: ['tab', 'width', 'height'],
  mixins: [
    ContentItemMixin,
  ],
  components: {
    ImageInput,
    Revisions,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    CropBoxDimensions() {
      return this.$store.getters.cropBoxDimensions;
    },
  },
  watch: {
    immediate: true,
    CropBoxDimensions(newDimensions, oldDimensions) {
      let returnValue = null;
      if (newDimensions !== oldDimensions) {
        returnValue = newDimensions;
      }

      return returnValue;
    },
  },
  mounted() {
    this.loading = true;
    const that = this;
    this.$store.dispatch('getContentItem', this.$route.params.contentId)
      .then(() => {
        const payload = { imageSrc: that.contentItem.fileContents, imageMode: 'view' };
        that.$store.dispatch('setCropImageTempSrc', payload);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    receiveFile(files) {
      if (!files) return;

      files = Array.from(files);

      const image = this.validateFile(files);

      if (!image) return;

      this.clearImageSrc();

      const reader = new FileReader();

      reader.onload = (e) => {
        this.setCropImageTempSrc(e.target.result);
      };

      reader.readAsDataURL(image);
      this.$refs.fileUpload.value = '';
    },
    validateFile(files) {
      const errors = [];
      let [image] = files;
      const size = (image.size / 1024 / 1024).toFixed(4);

      if (files.length !== 1) {
        errors.push('&bull; You may only upload one image file at a time.');
      }

      if (!_.includes(image.type, 'image')) {
        errors.push('&bull; You may only upload image files (JPG, PNG, & GIF)');
      }

      if (size > 5) {
        errors.push('&bull; Image file size may not exceed 5MB.');
      }

      if (errors.length) {
        image = false;
        this.showWarning(
          errors.join('<br>'),
          'The following errors occured',
        );
      }

      return image;
    },
    clearImageSrc() {
      this.clearCropImageTempSrc();
    },
    tempCropImage() {
      this.cropImage();
    },
    saveImage() {
      this.saveImage();
    },
  },
};
</script>

<style lang="scss">
#content-image {
  form[name="imageContentItemForm"] {
    display: inline-block;
    max-width: 900px;

    .page-buttons {
      min-width: 500px;
    }
  }

  form[name="revisionsForm"] {
    max-width: 500px;
  }
}
</style>
